module.exports = __webpack_public_path__ + "media/honey-icons/icon-clear-92e65135.svg";